import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocation, useSearchParams } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { useCallback, useMemo } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import AccountBreadcrumbs from '../breadcrumbs';
import useBanner from './useBanner';
import useMobileActiveMenu from '../components/useMobileActiveMenu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { LinkItem } from '../navigations/components';
import useIsMobile from '../components/useIsMobile';
import useBreadcrumbs from '../breadcrumbs/useBreadcrumbs';
const Container = styled(Box)(({ theme }) => ({
    textAlign: 'center',
    height: 'auto',
    paddingTop: '7%',
    paddingBottom: '7%',
}));
export default function AccountBanner({ menuItems }) {
    const { pathname } = useLocation();
    const [params] = useSearchParams();
    const id = useMemo(() => params.get('id'), [params]);
    const activeMenuItem = useMemo(() => menuItems.find((item) => pathname == item.url), [pathname, menuItems]);
    const [{ title }] = useBanner();
    const isMoble = useIsMobile();
    const [mobileMenuActiveState, setActive] = useMobileActiveMenu();
    const [{ backLink }] = useBreadcrumbs();
    const backLinkHref = useMemo(() => (pathname === (backLink === null || backLink === void 0 ? void 0 : backLink.href) && !id ? null : (backLink === null || backLink === void 0 ? void 0 : backLink.href) === '/account' ? null : (backLink === null || backLink === void 0 ? void 0 : backLink.href) || null), [backLink === null || backLink === void 0 ? void 0 : backLink.href, id, pathname]);
    const handleClearMobileActive = useCallback(() => {
        setActive((state) => {
            state.activePath = backLinkHref;
        });
    }, [backLinkHref, setActive]);
    return (_jsxs(Container, Object.assign({ className: 'image-cover cover-loaded', style: {
            backgroundImage: `url(${activeMenuItem === null || activeMenuItem === void 0 ? void 0 : activeMenuItem.image_banner})`,
            position: 'relative',
            minHeight: '100px',
        } }, { children: [mobileMenuActiveState.activePath && isMoble && (_jsx(LinkItem, Object.assign({ to: backLinkHref || '/account', onClick: handleClearMobileActive, sx: {
                    backgroundColor: 'transparent',
                    '&:focus,&:active,&:hover': {
                        backgroundColor: 'transparent',
                        color: '#fff',
                    },
                    position: 'absolute',
                    top: '50%',
                    left: '10px',
                    transform: 'translateY(-50%)',
                    fontSize: '1px',
                }, "data-fit-text": 1, "data-fit-text-parent": true }, { children: _jsx(ChevronLeftIcon, { fontSize: 'inherit' }) }))), _jsx(Typography, Object.assign({ sx: {
                    color: '#fff',
                }, fontWeight: 600, "data-fit-text": 1.8, "data-fit-text-parent": true }, { children: !isMoble || (isMoble && mobileMenuActiveState.activePath) ? title : 'MENY' })), _jsx(AccountBreadcrumbs, {})] })));
}
